/*
    ====================================================================================================================
    | **NOTICE**
    | THIS IS A GENERATED FILE USING THE SOURCE FILE:
    |  crab\common\lib\jvm\seeq-names\src\main\java\com\seeq\common\seeqnames\SeeqNames.java
    ====================================================================================================================
*/
export const SeeqNames = {
    DataLab: {
        Management: {
            Parameters: {
                Action: 'action',
                ProjectId: 'projectUuid',
            },
            Actions: {
                DeleteLocalPythonPackages: 'DELETE_LOCAL_PYTHON_PACKAGES',
                DeleteProjectFolder: 'DELETE_PROJECT_FOLDER',
                DeleteTrashFolder: 'DELETE_TRASH_FOLDER',
                FetchExecutingNotebooks: 'FETCH_EXECUTING_NOTEBOOKS',
                GetProjectsWithFileSystemInfo: 'GET_PROJECTS_WITH_FILE_SYSTEM_INFO',
                GetSdlDiskSpace: 'GET_SDL_DISK_SPACE',
                TerminateExecutingNotebook: 'TERMINATE_EXECUTING_NOTEBOOK',
                TerminateExecutingProject: 'TERMINATE_EXECUTING_PROJECT',
            },
        },
        Endpoints: {
            Consumption: '/data-lab-consumption',
            Job: '/data-lab-job',
            ManagementInternal: '/data-lab-management-internal',
        },
    },
    SystemFolderIdentifiers: {
        Corporate: '__Corporate__',
        Users: '__Users__',
        MyFolder: '__My_Folder__',
        ExternallyShared: '__Externally_Shared__',
    },
    ModelDataIds: {
        PrincipalComponentAnalysis: 'PRINCIPAL_COMPONENT_ANALYSIS_TOOL_MODEL',
        PartialLeastSquares: 'PARTIAL_LEAST_SQUARES_TOOL_MODEL',
        SelfOrganizingMap: 'SELF_ORGANIZING_MAP_TOOL_MODEL',
        IsolationForest: 'ISOLATION_FOREST_TOOL_MODEL',
        Clustering: 'CLUSTERING_TOOL_MODEL',
        OperationalizeStatistics: 'OPERATIONALIZE_STATISTICS_TOOL_MODEL',
        ControlLoopPerformanceMonitoring: 'CONTROL_LOOP_PERFORMANCE_MONITORING_MODEL',
        HeatExchangerPerformanceMonitoring: 'HEAT_EXCHANGER_PERFORMANCE_MONITORING_MODEL',
        StatBoundary: 'STAT_BOUNDARY_INDUSTRY_TEMPLATE',
    },
    ModelNames: {
        PrincipalComponentAnalysis: 'Principal Component Analysis',
        PartialLeastSquares: 'Partial Least Squares',
        SelfOrganizingMap: 'Self-Organizing Map',
        IsolationForest: 'Isolation Forest',
        Clustering: 'Clustering',
        OperationalizeStatistics: 'Operationalize Statistics',
        ControlLoopPerformanceMonitoring: 'Control Loop Performance Monitoring (CLPM)',
        HeatExchangerPerformanceMonitoring: 'Heat Exchanger Performance Monitoring (HEPM)',
        StatBoundary: 'Detect Process Change with Historical Comparison',
    },
    AnalysisViewType: {
        Trend: 'trend',
        StatisticsSummary: 'statisticsSummary',
    },
    FormulaType: {
        Capsule: 'Capsule',
        Condition: 'Condition',
        FormulaItem: 'FormulaItem',
        OnnxAnomalyModel: 'OnnxAnomalyModel',
        OnnxPredictionModel: 'OnnxPredictionModel',
        Sample: 'Sample',
        Scalar: 'Scalar',
        Signal: 'Signal',
        StatsSummary: 'StatsSummary',
    },
    AuditTrail: {
        ConfigurationOption: 'ConfigurationOption',
    },
    ImpactReport: {
        ImpactTableName: 'VCC_ImpactTable_v1',
        KPIPrefix: 'VC_KPI_',
        CategoryPrefix: 'VCC_',
        LayoutTableName: 'VCC_ImpactLayouts_v1',
        LayoutName: 'Layout Name',
        LayoutJson: 'Layout Json',
        LayoutColumnDefinitions: 'Layout Column Definitions',
        LayoutMapZoom: 'Layout Map Zoom',
        LayoutFilters: 'Layout Filters',
        LayoutOwner: 'Layout Owner',
        LayoutIsDefault: 'Is Default Layout',
        LayoutDefaultDatumId: 'impact-layout-default',
        Impact: 'impact',
        ImpactName: 'Name',
        ImpactDescription: 'Description',
        ImpactOwner: 'Impact Owner',
        ImpactStatus: 'Status',
        ImpactFormula: 'Formula',
        ImpactSavingsType: 'Savings Type',
        ImpactFrequency: 'Frequency',
        ImpactUnit: 'Unit',
        ImpactAsset: 'Asset',
        ImpactStartDate: 'Impact Start Date',
        ImpactEndDate: 'Impact End Date',
        ImpactQuantifyAmount: 'Impact Quantify Amount',
        AssignedToWorksheet: 'Worksheet Id',
        AssignedToWorkbook: 'Workbook Id',
        ImpactSite: 'Impact Site',
        Manager: 'Manager',
        ImpactLessonsLearned: 'Lesson Learned',
        ReviewComment: 'Review Comment',
        ReviewDate: 'Review Date',
        ReviewedBy: 'Reviewed By',
        ImpactFormulaParam: 'Formula Param',
        ImpactBasedOn: 'Based on',
        Location: 'Location',
    },
    CustomAggregators: {
        ConditionLabelContextLookup: 'ConditionLabelContextLookup',
        ConditionFlagContextLookup: 'ConditionFlagContextLookup',
        ConditionSuppressionContextLookup: 'ConditionSuppressionContextLookup',
        AllTrue: 'AllTrue',
        StringConcatLimited: 'StringConcatLimited',
        None: 'None',
        Aggregated: 'Aggregated',
        AggregatedMultipleMarker: 'Multiple',
    },
    VantageColumns: {
        Start: 'Start',
        End: 'End',
        Duration: 'Duration',
        AssetUUID: 'Asset UUID',
        Asset: 'Asset',
        IsUncertain: 'IsUncertain',
        CapsuleIdProperty: 'Capsule ID Property',
        Path: 'Path',
        UpdatedAt: 'Updated At',
        DeletedAt: 'Deleted at',
        Condition: 'Condition',
        Kind: 'Kind',
        Mutable: 'Mutable',
        Properties: 'Properties',
        Suppressed: 'Suppressed',
        Formula: 'Formula',
        Reviewed: 'Reviewed',
        Flagged: 'Flagged',
        Labels: 'Labels',
        CapsuleCount: 'Capsule Count',
    },
    GraphQL: {
        DataLoaderRegistry: {
            CreatorMetadataLoader: 'CREATOR_METADATA_LOADER',
            ItemMetadataLoader: 'ITEM_METADATA_LOADER',
        },
    },
    SeeqContextNameSpace: {
        SeeqLabelNamespace: '__',
        UsageRestrictedLabelNamespace: '__Seeq.',
        VantageLabelCategoryNamespace: '__Vantage',
        UserDefinedContextNamespace: 'UserDefinedContext',
        ReasonCodeNamespace: 'reasonCode',
        SuppressionLabelCategoryName: '__Seeq.suppression',
        FlagLabelCategoryName: '__Vantage.flag',
        ReviewedLabelCategoryName: '__Vantage.reviewed',
        VantageSuppressionLabelCategoryName: '__Vantage.suppression',
        LabelsLabelCategoryName: '__Vantage.labels',
        ReasonCodesCategoryName: '__Vantage.reason_codes',
        FlaggedContextLabelName: 'flag',
        Operations: {
            Created: 'CREATED',
            Updated: 'UPDATED',
            Deleted: 'DELETED',
        },
        DataTypes: {
            Label: 'LABEL',
            Comment: 'COMMENT',
            Opaque: 'OPAQUE',
            Numeric: 'NUMERIC',
        },
        SuppressionLabels: {
            Ongoing: 'ongoing',
            Expired: 'expired',
            EndedByUser: 'ended-by-user',
            EndedByCondition: 'ended-by-condition',
            Errored: 'errored',
            EndedUnmonitored: 'ended-unmonitored',
        },
    },
    MlService: {
        PrincipalComponentAnalysis: {
            Connection: {
                Name: 'Seeq ML Principal Component Analysis',
                Url: 'pca',
                UdfPackage: 'seeqPCA',
                UdfName: 'principalComponentAnalysis',
            },
        },
        Clustering: {
            Connection: {
                Name: 'Seeq ML Clustering',
                Url: 'cluster',
                UdfPackage: 'seeqClustering',
                UdfName: 'cluster',
            },
        },
        IsolationForest: {
            Connection: {
                Name: 'Seeq ML Isolation Forest',
                Url: 'if',
                UdfPackage: 'seeqIF',
                UdfName: 'isolationForest',
            },
        },
        SelfOrganizingMap: {
            Connection: {
                Name: 'Seeq ML Self-Organizing Map',
                Url: 'som',
                UdfPackage: 'seeqSOM',
                UdfName: 'selfOrganizingMap',
            },
        },
        PlsRegression: {
            Connection: {
                Name: 'Seeq ML PLS Regression',
                Url: 'pls',
                UdfPackage: 'seeqPLS',
                UdfName: 'plsRegression',
            },
        },
    },
    Origins: {
        ActionBoard: 'action_board',
        AddOn: 'Add-on',
        Administration: 'Administration',
        Analysis: 'Analysis',
        Chat: 'chat',
        DataLab: 'Data Lab',
        DataLabInteractive: 'Data Lab (Interactive)',
        DataLabJob: 'Data Lab (Job)',
        DatasourceProxy: 'DatasourceProxy',
        ExportPrefix: 'Export to',
        GenAI: 'genai',
        HomeScreen: 'Home Screen',
        JvmLink: 'jvm-link',
        LogTracker: 'logs',
        NetLink: 'net-link',
        Orchestrator: 'Orchestrator',
        Organizer: 'Organizer',
        Plugin: 'plugin',
        Renderer: 'Renderer',
        Screenshot: 'Screenshot',
        ScreenshotPowerpoint: 'Screenshot (PowerPoint Export)',
        SpyStandalone: 'SPy (Standalone)',
        Thumbnail: 'Thumbnail',
        Topic: 'Topic',
        Unknown: 'Unknown',
        Workbench: 'Workbench',
    },
    Consumption: {
        Administration: 'Administration',
        AIAssistantPrefix: 'AI Assistant',
        ConditionMonitors: 'ConditionMonitors',
        Connections: 'Connections',
        DataLabResourcesPrefix: 'Data Lab Resources',
        ImpactReports: 'Impact Reports',
        OData: 'OData',
        Screenshot: 'Screenshot',
        SignalMonitors: 'SignalMonitors',
        Topic: 'Topic',
        Vantage: 'Vantage',
    },
    Capabilities: {
        ScalingTables: {
            DataId: 'ScalingTablesCapability',
            CollectiveName: 'scaling tables users',
        },
        LogViewer: {
            DataId: 'LogViewerCapability',
            CollectiveName: 'log viewers',
        },
        EarlyAccess: {
            DataId: 'EarlyAccessCapability',
            CollectiveName: 'early feature access users',
        },
        DatasourceAdministration: {
            DataId: 'DatasourceAdministrationCapability',
            CollectiveName: 'datasource administrators',
        },
        UserAdministration: {
            DataId: 'UserAdministrationCapability',
            CollectiveName: 'user administrators',
        },
        AuditTrail: {
            DataId: 'AuditTrailCapability',
            CollectiveName: 'audit trail viewers',
        },
        AnalyticsAdministration: {
            DataId: 'AnalyticsAdministrationCapability',
            CollectiveName: 'analytics administrators',
        },
        Administration: {
            DataId: 'Administrators',
            CollectiveName: 'administrators',
        },
    },
    RequestIdPrefixes: {
        Unique: 'R^',
        Screenshot: 'ScreenshotCapture^',
        Invocation: 'Invocation^',
    },
    PdfSettings: {
        MarginUnits: {
            Inches: 'in',
            Millimeters: 'mm',
            Centimeters: 'cm',
            Pixels: 'px',
        },
        PageSize: {
            Letter: 'Letter',
            Legal: 'Legal',
            A5: 'A5',
            A4: 'A4',
            A3: 'A3',
            Tabloid: 'Tabloid',
        },
        PageOrientation: {
            Portrait: 'Portrait',
            Landscape: 'Landscape',
        },
        Defaults: {
            PageOrientation: 'Portrait',
            PageSize: 'Letter',
            PageMargin: '0.5in',
        },
    },
    Database: {
        Utils: {
            EmptyGuid: '00000000-0000-0000-0000-000000000000',
        },
        Schemas: {
            MaterializedTables: 'materialized_tables',
        },
    },
    Models: {
        InstanceNameInputFeatureName: 'SEEQ_MODEL_INSTANCE_NAME',
    },
    MaterializedTables: {
        DatumIdColumn: 'datum id',
        ItemIdColumn: 'item id',
        EventDataColumn: 'event data',
        ContextTablePrefix: 'context_',
        ContextCreatorIdColumn: 'creator_id',
        ContextUpdaterIdColumn: 'updater_id',
        ContextArchiverColumn: 'archiver_id',
        CreatedAtColumn: 'created at',
        UpdatedAtColumn: 'table updated at',
        UniqueRowId: 'Existing Row Identifier',
        CsvItemIdColumn: 'csv item id',
        LastCapsuleStateColumn: 'Last Capsule State',
        HierarchyNodeIdColumn: 'node_id',
        HierarchyNodeColumnColumn: 'node_column',
        HierarchyNodeTextColumn: 'node_text_column',
        ItemsTableJoinSuffix: '_join',
        MaterializedTableJoinSuffix: '_mt_join',
        Parameters: {
            PropertyName: 'propertyName',
            PropertyNames: 'propertyNames',
            PropertyValue: 'propertyValue',
            PropertyMatchOperator: 'propertyMatchOperator',
            PropertyMatchOperators: 'propertyMatchOperators',
            Level: 'level',
            Separator: 'separator',
            Direction: 'direction',
            Formula: 'formula',
            ExcludeGloballyScoped: 'excludeGloballyScoped',
            ParametersName: 'parameters',
            Name: 'name',
            NameBinding: 'nameBinding',
            Description: 'description',
            ColumnIndexDataId: 'columnIndexDataId',
            ScopedTo: 'scopedTo',
            IdentityId: 'identityId',
            PermissionString: 'permissionString',
            SecurityString: 'securityString',
            ColumnIndex: 'columnIndex',
            ColumnIndexes: 'columnIndexes',
            ColumnIndexItem: 'columnIndexItem',
            ColumnIndexValue: 'columnIndexValue',
            ColumnIndexSourceText: 'columnIndexSourceText',
            ColumnIndexReplacement: 'columnIndexReplacement',
            ColumnIndexUnitOfMeasure: 'columnIndexUnitOfMeasure',
            Constant: 'constant',
            IsRoot: 'isRoot',
            ItemType: 'itemType',
            ItemTypes: 'itemTypes',
            Regex: 'regex',
            Replacement: 'replacement',
            RemoveNonMatches: 'removeNonMatches',
            LookupValue: 'lookupValue',
            LookupMatchOperator: 'lookupMatchOperator',
            VariableParameters: 'variableParameters',
            VariableParameterStrings: 'variableParameterStrings',
            Prefix: 'prefix',
            Suffix: 'suffix',
            PropertyValues: 'propertyValues',
            PropertyValueTypes: 'propertyValueTypes',
            PropertyValueUoms: 'propertyValueUoms',
            AncestorProperty: 'ancestorProperty',
            ColumnId: 'columnId',
            ColumnUom: 'columnUom',
            BooleanValue: 'booleanValue',
            StringValue: 'stringValue',
            NumericValue: 'numericValue',
            UomString: 'uomString',
            UUIDValue: 'uuidValue',
            TimestampValue: 'timestampValue',
            DatasourceId: 'datasourceId',
            Params: 'parameters',
        },
        Rules: {
            Ancestor: 'ancestor',
            AssetCreator: 'assetCreator',
            ConcatColumns: 'concatColumns',
            Descendant: 'descendant',
            EventProperty: 'eventProperty',
            PreserveExisting: 'preserveExisting',
            FormulaCreator: 'formulaCreator',
            GetItemProperty: 'getItemProperty',
            ItemSearch: 'itemSearch',
            Path: 'path',
            PathSearch: 'pathSearch',
            NumericScalarCreator: 'numericScalarCreator',
            SearchAncestor: 'searchAncestor',
            SetItemProperty: 'setItemProperty',
            StringScalarCreator: 'stringScalarCreator',
            TextExtractor: 'textExtractor',
            TextReplacement: 'textReplacement',
            TreePathCreator: 'treePathCreator',
            Manager: 'manager',
            ItemType: 'itemType',
            Datasource: 'datasource',
            ContextCondition: 'contextCondition',
            EventAssetCreator: 'eventAssetCreator',
            FindProperty: 'findProperty',
            DescendantSearch: 'descendantSearch',
            FindDescendant: {
                BaseFindDescendant: 'findDescendant',
                ItemFindDescendant: 'itemFindDescendant',
                StringFindDescendant: 'stringFindDescendant',
            },
            ScalarCreator: {
                BaseScalarCreator: 'scalarCreator',
                NumericScalarCreator: 'numericScalarCreator',
                StringScalarCreator: 'stringScalarCreator',
            },
            Overrides: {
                Override: 'Override',
                BooleanOverride: 'booleanOverride',
                NumericOverride: 'numericOverride',
                StringOverride: 'stringOverride',
                TimestampOverride: 'timestampOverride',
                UUIDOverride: 'uuidOverride',
            },
            Constant: {
                BaseConstant: 'constant',
                BooleanConstant: 'booleanConstant',
                NumericConstant: 'numericConstant',
                StringConstant: 'stringConstant',
                TimestampConstant: 'timestampConstant',
                UUIDConstant: 'uuidConstant',
                BooleanLookupConstant: 'booleanLookupConstant',
                NumericLookupConstant: 'numericLookupConstant',
                StringLookupConstant: 'stringLookupConstant',
                TimestampLookupConstant: 'timestampLookupConstant',
                UUIDLookupConstant: 'uuidLookupConstant',
            },
        },
        FormulaAcross: {
            AssetColumn: 'Asset',
            PathColumn: 'Path',
            DatasourceColumn: 'Datasource',
            ValueUomColumn: 'Value UOM',
            SourceColumnIdColumn: 'Source Column ID',
            SearchAncestorPrefix: 'Search Ancestor',
        },
        Vantage: {
            ExtinctColumn: 'Extinct',
        },
    },
    Injection: {
        SystemState: 'SystemState',
        SystemUser: 'SystemUser',
        TreeDefinition: 'TreeDefinition',
    },
    Ignition: {
        AgentName: 'Ignition Module Agent',
    },
    Connectors: {
        SeeqDeveloperName: 'Seeq',
        UnknownThirdPartyDeveloperName: 'third-party developer',
        ConnectionsJsonKey: 'Connections',
        DatasourceManagedJsonKey: 'DatasourceManaged',
        Connections: {
            NameJsonKey: 'Name',
            DatasourceIdJsonKey: 'Id',
            EnabledJsonKey: 'Enabled',
            IndexingJsonKey: 'Indexing',
            FrequencyJsonKey: 'Frequency',
            NextIndexingAtJsonKey: 'Next',
            OnStartupAndConfigChangeJsonKey: 'OnStartupAndConfigChange',
            TransformsJsonKey: 'Transforms',
            MaxConcurrentRequestsJsonKey: 'MaxConcurrentRequests',
            MaxResultsPerRequestJsonKey: 'MaxResultsPerRequest',
            FieldConfigurationsJsonKey: 'FieldConfigurations',
            SecretFieldPlaceholderValue: '<placeholder>',
            SyncStatus: {
                Unknown: 'SYNC_UNKNOWN',
                Initializing: 'SYNC_INITIALIZING',
                InProgress: 'SYNC_IN_PROGRESS',
                ArchivingDeletedItems: 'SYNC_ARCHIVING_DELETED_ITEMS',
                Complete: 'SYNC_COMPLETE',
                Success: 'SYNC_SUCCESS',
                Failed: 'SYNC_FAILED',
            },
            Status: {
                Connecting: 'CONNECTING',
                Connected: 'CONNECTED',
                Disconnected: 'DISCONNECTED',
                Disabled: 'DISABLED',
            },
            SyncMode: {
                None: 'NONE',
                Incremental: 'INCREMENTAL',
                Full: 'FULL',
            },
            SyncResult: {
                InProgress: 'IN_PROGRESS',
                Success: 'SUCCESS',
                Failed: 'FAILED',
                Interrupted: 'INTERRUPTED',
            },
            MultivaluedSamplesBehavior: {
                KeepLast: 'Keep Last',
                Stagger: 'Stagger',
            },
        },
    },
    Agents: {
        AgentKeysFolderName: 'agent-keys',
        AgentTempFolderName: 'agent-temp',
        ConnectorsJsonKey: 'Connectors',
        WebSockets: {
            PingPrefix: 'SEEQ-WS-PING-MSG-',
        },
        Status: {
            Connecting: 'CONNECTING',
            Connected: 'CONNECTED',
            Disconnected: 'DISCONNECTED',
            PreProvisioned: 'PREPROVISIONED',
        },
        Connectors: {
            NameJsonKey: 'Name',
            EnabledJsonKey: 'Enabled',
        },
    },
    TreeType: {
        SeeqWorkbench: 'Seeq Workbench',
    },
    OData: {
        ExportEntitySetSuffix: '_DataSet',
        ODataV4ServiceSuffix: '.svc/',
    },
    CleanUpJobsGroup: {
        AnnotationImages: 'AnnotationOrphanedImageCleanerJob',
        WorksheetMaintenance: 'WorksheetMaintenanceJob',
    },
    JobGroup: {
        Screenshot: 'ScreenshotCapture',
        DateRange: 'DateRangeJobs',
        Report: 'ReportJobs',
        Notebook: 'NotebookJobs',
        CleanUp: 'CleanUpJobs',
        ReportTemplate: 'ReportTemplateJobs',
        ConditionMonitor: 'ConditionMonitorNotifications',
        WorksheetThumbnail: 'WorksheetThumbnail',
        ItemFinder: 'ItemFinder',
        SignalMonitor: 'SignalMonitor',
        MentionEmailNotification: 'MentionEmailNotification',
        SeeqModels: 'SeeqModelsJobs',
        CustomAgentSchedule: 'CustomAgentSchedule',
    },
    Logging: {
        MigrationsCompleteFile: 'migrations_complete_',
        RemoteAgents: {
            MDCFilenameKey: 'agentlogfilename',
        },
        Appserver: {
            MDCFilenameKey: 'logfilename',
            DefaultFile: 'appserver',
            StartupFile: 'appserver-startup',
            UpgradeFile: 'appserver-upgrade',
            AsyncUpgradeFile: 'appserver-async-upgrade',
            LicensingFile: 'appserver-licensing',
            Requests: 'appserver-requests',
            RequestMonitors: 'appserver-requestmonitors',
            Units: 'appserver-units',
            Users: 'appserver-users',
            IntervalAnalysis: {
                FetchCritic: 'appserver-intervalanalysis-fetchcritic',
            },
        },
    },
    RemoteDatasourceClasses: {
        LDAP: 'LDAP',
        OAuth2: 'OAuth 2.0',
        WindowsAuth: 'Windows Auth',
        ADX: 'ADX',
        APRM: 'AspenTech APRM',
        BigQuery: 'BigQuery',
        Canary: 'Canary',
        ChaosMonkey: 'Chaos Monkey',
        Cognite: 'Cognite',
        CONNECTDataServices: 'CONNECT Data Services',
        CygNet: 'CygNet',
        DataPARC: 'dataPARC',
        ExampleData: 'Time Series CSV Files',
        AddOnCalcPython: 'Add-on Calculation Python',
        AddOnCalcWebhook: 'Add-on Calculation Webhook',
        AddOnCalcExcel: 'Add-on Calculation Excel VBA',
        FileFolders: 'FileFolders',
        GEProficy: 'GE Proficy',
        GPM: 'GreenPowerMonitor',
        IBAHD: 'IbaHD',
        Ignition: 'Ignition Gateway',
        InfluxDB: 'InfluxDB',
        InfluxDB2: 'InfluxDB 2',
        Inmation: 'Inmation',
        IP21: 'AspenTech IP21',
        MetNet: 'MetNet',
        NOAAWeather: 'NOAA Weather Service',
        Omnia: 'Equinor Omnia Plant',
        OPCHDA: 'OPC-HDA',
        OPCUA: 'OPC-UA',
        OSIsoftAF: 'OSIsoft AF',
        OSIsoftAFEventFrames: 'OSIsoft AF Event Frames',
        OSIsoftPI: 'OSIsoft PI',
        SeeqToSeeq: 'Seeq to Seeq',
        SQL: 'SQL',
        StressTest: 'Stress Test',
        TimeStream: 'TimeStream',
        TreeFile: 'Tree File',
        WITSML: 'WITSML',
        Wonderware: 'Wonderware',
        XHQ: 'XHQ',
    },
    SeeqSaasAdminDatasource: {
        DatasourceClass: 'OAuth 2.0',
        DatasourceId: 'Seeq Saas Admin',
        DatasourceName: 'Seeq Saas Admin',
    },
    IdentityProviderDatasourceClasses: {
        LDAP: 'LDAP',
        OAuth2: 'OAuth 2.0',
        SeeqAuth: 'Auth',
        WindowsAuth: 'Windows Auth',
    },
    LocalDatasources: {
        Templates: {
            DatasourceClass: 'Seeq Templates',
            Industry: {
                DatasourceId: 'Industry Templates',
                DatasourceName: 'Industry Templates',
            },
            User: {
                DatasourceId: 'User Templates',
                DatasourceName: 'User Templates',
            },
            System: {
                DatasourceId: 'System Templates',
                DatasourceName: 'System Templates',
            },
        },
        MaterializedTables: {
            DatasourceClass: 'Seeq Materialized Tables',
        },
        SeeqDataLab: {
            DatasourceClass: 'Seeq Data Lab',
        },
        SeeqMetadataItemStorage: {
            DatasourceClass: 'Seeq Metadata',
            DatasourceId: 'Seeq Metadata',
            DatasourceName: 'Seeq Metadata',
        },
        SeeqCalculationItemStorage: {
            DatasourceClass: 'Seeq Calculations',
            DatasourceId: 'Seeq Calculations',
            DatasourceName: 'Seeq Calculations',
        },
        Monitors: {
            DatasourceClass: 'Monitors',
            DatasourceId: 'monitors',
            DatasourceName: 'Seeq Monitors',
        },
        Authentication: {
            DatasourceClass: 'Auth',
            DatasourceId: 'Seeq',
            DatasourceName: 'Seeq',
            PasswordSpecialCharacters: '!@#$%^&*()_+-=[]{}|;:,.<>?/',
        },
        FileSignalStorage: {
            DatasourceClass: 'Seeq - Signal Datasource',
            DatasourceId: 'Signal Datasource',
            DatasourceName: 'Seeq Signal Datasource',
        },
        ContextDatumStorage: {
            DatasourceClass: 'Context Datum Storage',
            DatasourceId: 'Context Datum Storage',
            DatasourceName: 'Context Datum Storage',
        },
        PostgresDatums: {
            DatasourceClass: 'Postgres Datums',
            DatasourceId: 'default',
            DatasourceName: 'Seeq Conditions Database',
        },
        Datafile: {
            DatasourceClass: 'Imported CSV Files',
            DatasourceId: 'Imported CSV Files',
            DatasourceName: 'Imported CSV Files',
        },
    },
    SwaggerApiNames: {
        AddOns: 'AddOns',
        Agents: 'Agents',
        CustomAgents: 'CustomAgents',
        Applications: 'Applications',
        ApprovalFlows: 'ApprovalFlows',
        ApprovalFlowSteps: 'ApprovalFlowSteps',
        ApprovalFlowAssignments: 'ApprovalFlowAssignments',
        Audit: 'Audit',
        Auth: 'Auth',
        Assets: 'Assets',
        Boards: 'Boards',
        Folders: 'Folders',
        Networks: 'Networks',
        Items: 'Items',
        Reports: 'Reports',
        Jobs: 'Jobs',
        Logs: 'Logs',
        Trees: 'Trees',
        Signals: 'Signals',
        Capsules: 'Capsules',
        Conditions: 'Conditions',
        Metrics: 'Metrics',
        Formulas: 'Formulas',
        Functions: 'Functions',
        Requests: 'Requests',
        Tables: 'Tables',
        Workbooks: 'Workbooks',
        Worksheets: 'Worksheets',
        Export: 'Export',
        Annotations: 'Annotations',
        Datasources: 'Datasources',
        Datafiles: 'Datafiles',
        Users: 'Users',
        UserGroups: 'UserGroups',
        AccessKeys: 'AccessKeys',
        Usage: 'Usage',
        Scalars: 'Scalars',
        Subscriptions: 'Subscriptions',
        System: 'System',
        Import: 'Import',
        Monitors: 'Monitors',
        Projects: 'Projects',
        Content: 'Content',
        ReportTemplates: 'ReportTemplates',
        ConditionMonitors: 'ConditionMonitors',
        ConditionMonitorRuns: 'ConditionMonitorRuns',
        ItemFinderRuns: 'ItemFinderRuns',
        SignalMonitors: 'SignalMonitors',
        Plugins: 'Plugins',
        Displays: 'Displays',
        DisplayTemplates: 'DisplayTemplates',
        NotificationConfigurations: 'NotificationConfigurations',
        Label: 'Label',
        Context: 'Context',
        TableDefinitions: 'TableDefinitions',
        MaterializedTables: 'MaterializedTables',
        Hierarchies: 'Hierarchies',
        Templates: 'Templates',
        GraphQL: 'GraphQL',
        Cache: 'Cache',
        Scim: 'SCIM',
        MarkdownItems: 'MarkdownItems',
        CalculatedTables: 'CalculatedTables',
        MarkdownLinks: 'MarkdownLinks',
        Sharing: 'Sharing',
        StoredTables: 'StoredTables',
        Extensions: {
            Experimental: 'x-experimental',
            DeprecatedReason: 'x-deprecated-reason',
            DeprecatedReasonProperties: {
                Reason: 'reason',
            },
        },
    },
    Channels: {
        AgentsStatus: 'agents-status',
        DatasourcesStatus: 'datasources-status',
        Broadcast: 'broadcast',
        LiveScreenshot: 'live-screenshot',
        RequestsProgress: 'requests-progress',
        WorkbookChannel: 'workbook',
        LockingChannel: 'workbook-locking',
        ThumbnailChannel: 'workbook-thumbnail',
        WorkstepChannel: 'workstep',
        ReportUpdateChannel: 'report-update',
        SignalMonitor: 'signal-monitor',
        TableMaterializerChannel: 'table-materializer',
        Context: 'context',
    },
    API: {
        Ace: '/ace',
        AddOns: '/add-ons',
        AddOnTools: '/addOnTools',
        Agents: '/agents',
        CustomAgents: '/custom-agents',
        Applications: '/applications',
        ApprovalFlows: '/approval-flows',
        Audit: '/audit',
        Auth: '/auth',
        Assets: '/assets',
        GenAI: '/genai',
        Folders: '/folders',
        Networks: '/networks',
        Items: '/items',
        ItemFinders: '/finders',
        ItemFinderRuns: '/item-finder-runs',
        Reports: '/reports',
        Jobs: '/jobs',
        Logs: '/logs',
        Batch: '/batch',
        Trees: '/trees',
        AssetTrees: '/trees/assets',
        Signals: '/signals',
        Samples: '/samples',
        Capsules: '/capsules',
        Conditions: '/conditions',
        ConditionMonitors: '/condition-monitors',
        ConditionMonitorRuns: '/condition-monitor-runs',
        SignalMonitors: '/signal-monitors',
        Metrics: '/metrics',
        Thresholds: '/thresholds',
        Formulas: '/formulas',
        Docs: '/docs',
        Functions: '/functions',
        Packages: '/packages',
        Scalars: '/scalars',
        Properties: '/properties',
        Requests: '/requests',
        Tables: '/tables',
        Workbooks: '/workbooks',
        Worksheets: '/worksheets',
        Worksteps: '/worksteps',
        Export: '/export',
        Annotations: '/annotations',
        Datasources: '/datasources',
        Datafiles: '/datafiles',
        Users: '/users',
        UserGroups: '/usergroups',
        AccessKeys: '/accesskeys',
        OData: '/odata.svc',
        ODataV4: '/odata',
        System: '/system',
        Import: '/import',
        Status: '/status',
        Shutdown: '/shutdown',
        Screenshots: '/screenshots',
        Subscriptions: '/subscriptions',
        Monitors: '/system/monitors',
        Configuration: '/system/configuration',
        Installer: '/system/installer',
        Projects: '/projects',
        Content: '/content',
        ReportTemplates: '/report-templates',
        DateRanges: '/date-ranges',
        AssetSelections: '/asset-selections',
        Plugins: '/plugins',
        Displays: '/displays',
        DisplayTemplates: '/display-templates',
        Usage: '/usage',
        NotificationConfigurations: '/notification-configurations',
        Labels: '/labels',
        Context: '/context',
        ContextComments: '/comments',
        ContextLabels: '/labels',
        ContextOpaque: '/opaque',
        ContextNumeric: '/numeric',
        TableDefinitions: '/table-definitions',
        MaterializedTables: '/materialized-tables',
        Hierarchies: '/hierarchies',
        ReasonCodes: '/reason-codes',
        Templates: '/templates',
        GraphQL: '/graphql',
        Cache: '/cache',
        MarkdownItems: '/markdown-items',
        MarkdownLinks: '/markdown/links',
        StoredTables: '/stored-tables',
        Boards: '/boards',
        DrillDimensions: '/drill-dimensions',
        CalculatedTables: '/calculated-tables',
        Sharing: '/sharing',
        ScimUsers: 'Users',
        ScimGroups: 'Groups',
        ScimToken: 'token',
        ErrorMessages: {
            AttemptedToSetScopeOnAGloballyScopedItem: 'Attempted to set scope on a globally scoped item',
            CancelledDueToTooManyRetries: 'The request was canceled due to being retried too many times',
            AtLeastOneItemMustBelongToAsset: 'At least one of the items must belong to an asset.',
        },
        AddOnToolLinkType: {
            Window: 'window',
            Tab: 'tab',
            None: 'none',
        },
        AddOnToolLaunchLocation: {
            Homescreen: 'homescreen',
            ToolsPane: 'toolsPane',
        },
        PropertyIds: {
            RequestInformation: 'com.seeq.requestinformation',
        },
        Cookies: {
            Auth: 'sq-auth',
            Csrf: 'sq-csrf',
        },
        QueryParams: {
            Admin: 'admin',
            ClientInteractiveSessionId: 'interactiveId',
            SkipAutoSubscribe: 'skipAutoSubscribe',
            Creator: 'creator',
            Name: 'name',
            requestId: 'requestId',
            ContentCount: 'contentCount',
        },
        Headers: {
            AcceptRanges: 'Accept-Ranges',
            Action: 'x-sq-action',
            Async: 'x-sq-async',
            AsyncJob: 'x-sq-async-job',
            Auth: 'x-sq-auth',
            ExpirationTime: 'x-sq-expiration-time',
            IdentityPath: 'x-sq-identity-path',
            ContentRange: 'Content-Range',
            Csrf: 'x-sq-csrf',
            ForwardedFor: 'x-forwarded-for',
            ForwardedHost: 'x-forwarded-host',
            CFConnectingIP: 'cf-connecting-ip',
            CFRay: 'cf-ray',
            InteractiveSessionId: 'Session-Id',
            PoolId: 'x-sq-pool-id',
            PoolConnectedOnDegradedState: 'x-sq-pool-connected-on-degraded-state',
            Range: 'Range',
            RequestId: 'x-sq-request-id',
            RequestOrigin: 'x-sq-origin',
            RequestOriginURL: 'x-sq-origin-url',
            RequestOriginLabel: 'x-sq-origin-label',
            Server: 'Server',
            ServerMeters: 'Server-Meters',
            ServerTiming: 'Server-Timing',
            Expect: 'Expect',
            DateRangeStart: 'x-sq-daterange-start',
            DateRangeEnd: 'x-sq-daterange-end',
            Height: 'x-sq-height',
            Width: 'x-sq-width',
            WarningMessage: 'x-sq-warning-message',
            ExportTruncated: 'x-sq-export-truncated',
            SourceJobKey: 'x-sq-source-job-key',
            Timings: {
                Datasource: 'Datasource',
                Cache: 'Cache',
                Processing: 'Processing',
                GC: 'GC',
                RequestQueue: 'Request Queue',
                CalcEngineQueue: 'Calc Engine Queue',
                SeeqDatabase: 'Seeq Database',
                Total: 'Total',
            },
            Meters: {
                DatasourceSamplesRead: 'Datasource Samples Read',
                DatasourceCapsulesRead: 'Datasource Capsules Read',
                CacheSamplesRead: 'Cache Samples Read',
                CacheCapsulesRead: 'Cache Capsules Read',
                CacheInMemorySamplesRead: 'Cache In-Memory Samples Read',
                CacheInMemoryCapsulesRead: 'Cache In-Memory Capsules Read',
                DatabaseItemsRead: 'Database Items Read',
                DatabaseRelationshipsRead: 'Database Relationships Read',
            },
        },
        Flags: {
            AllProperties: '@allProperties',
            ExcludeGloballyScoped: '@excludeGloballyScoped',
            IncludeUnsearchable: '@includeUnsearchable',
        },
        TranslationKeyPrefixes: {
            Capabilities: 'API.CAPABILITIES.',
        },
    },
    UnitTest: {
        Timestamp1: '1990-03-07T09:58:20.888888Z',
        Timestamp2: '1990-04-08T10:59:21.999999Z',
        NonExistentGuid: '1CB64296-FC3E-4221-9A7F-947A0AB99807',
    },
    Edges: {
        Owns: 'owns',
        Created: 'created',
        Installed: 'installed',
        Contains: 'contains',
        FolderContains: 'folder contains',
        MemberOf: 'member of',
        InterestedIn: 'interested in',
        ReportsOn: 'reports on',
        RepliesTo: 'replies to',
        RecentlyAccessed: 'recently accessed',
        HasWorksheet: 'has worksheet',
        HasWorkstep: 'has workstep',
        CurrentWorkstep: 'current workstep',
        TemplateWorkstep: 'template workstep',
        HasParameter: 'has parameter',
        UsesFunction: 'uses function',
        AssociatedTo: 'associated to',
        /* DEPRECATED, Deprecated. See SeeqNames.java for more info */
        AccessFor: 'access for',
        /* DEPRECATED, Deprecated. See SeeqNames.java for more info */
        HasAce: 'has access control entry',
        HasPinned: 'has pinned',
        Measuring: 'measuring',
        HasAggregationSignal: 'has aggregation signal',
        HasAggregationCondition: 'has aggregation condition',
        HasAggregationFormulaFunction: 'has aggregation formula function',
        BoundedBy: 'bounded by',
        HasThreshold: 'has threshold',
        HasConditionThreshold: 'has condition threshold',
        HomeFolder: 'home folder',
        HasManager: 'has manager',
        PackageContainsUDF: 'package contains user defined function',
        PackageContainsDoc: 'package contains formula doc',
        DocumentedBy: 'documented by',
        AgentContainsConnector: 'agent contains connector',
        ConnectionCreatedByConnector: 'connection created by connector',
        Renders: 'renders',
        RunsNotebook: 'runs notebook',
        SourceWorksheet: 'source worksheet',
        SourceWorkstep: 'source workstep',
        HasAsset: 'has asset',
        HasAssetSelection: 'has asset selection',
        HasAssetSelections: 'has asset selections',
        HasCondition: 'has condition',
        HasItemFinder: 'has item finder',
        HasTableDefinition: 'HasTableDefinition',
        HasExport: 'has export',
        HasContent: 'has content',
        HasDateRange: 'has date range',
        HasDateRanges: 'has date ranges',
        HasDesignatedScimUser: 'has designated scim user',
        HasServicePrincipal: 'has service principal',
        HasScheduledNotebook: 'has scheduled notebook',
        HasTemplate: 'has template',
        SubscribedTo: 'subscribed to',
        ContainsContextFor: 'contains context for',
        HierarchyOf: 'Hierarchy Of',
        HasUserGroup: 'has usergroup',
        HasFolder: 'has folder',
        CustomAgentHasAutomationConditionMonitor: 'custom agent has automation condition monitor',
        CustomAgentHasAutomationReport: 'custom agent has automation report',
        CustomAgentContainsVersionHistory: 'custom agent contains version history',
        CustomAgentContainsWorkflow: 'custom agent contains workflow',
        ModelContainerContainsVersionHistory: 'model container contains version history',
        ModelContainerContainsModel: 'model container contains model',
    },
    Types: {
        Asset: 'Asset',
        AssetSelection: 'AssetSelection',
        AccessControlEntry: 'AccessControlEntry',
        Application: 'Application',
        StoredSignal: 'StoredSignal',
        Datasource: 'Datasource',
        Datafile: 'Datafile',
        CalculatedSignal: 'CalculatedSignal',
        FormulaItem: 'FormulaItem',
        Signal: 'Signal',
        TreeDefinition: 'TreeDefinition',
        Identity: 'Identity',
        User: 'User',
        UserGroup: 'UserGroup',
        AccessKey: 'AccessKey',
        SystemState: 'SystemState',
        Export: 'Export',
        ProjectLink: 'ProjectLink',
        AddOnTool: 'AddOnTool',
        BaseAnnotation: 'BaseAnnotation',
        Report: 'Report',
        ReportTemplate: 'ReportTemplate',
        Journal: 'Journal',
        Reply: 'Reply',
        ItemFinder: 'ItemFinder',
        Condition: 'Condition',
        ConditionMonitor: 'ConditionMonitor',
        Capsule: 'Capsule',
        StoredCondition: 'StoredCondition',
        CalculatedCondition: 'CalculatedCondition',
        Scalar: 'ScalarItem',
        LiteralScalar: 'LiteralScalar',
        CalculatedScalar: 'CalculatedScalar',
        FormulaFunction: 'FormulaFunction',
        AggregatingFormulaFunction: 'AggregatingFormulaFunction',
        Chart: 'Chart',
        UserDefinedFormulaFunction: 'UserDefinedFormulaFunction',
        FormulaPackage: 'FormulaPackage',
        FormulaDoc: 'FormulaDoc',
        FormulaPackageDoc: 'FormulaPackageDoc',
        SignalMonitor: 'SignalMonitor',
        ThresholdMetric: 'ThresholdMetric',
        Display: 'Display',
        DisplayTemplate: 'DisplayTemplate',
        Folder: 'Folder',
        Project: 'Project',
        Content: 'Content',
        ImageContent: 'ImageContent',
        ReactJsonContent: 'ReactJsonContent',
        DateRange: 'DateRange',
        ScheduledNotebook: 'ScheduledNotebook',
        AddOn: 'AddOn',
        Plugin: 'Plugin',
        Connection: 'Connection',
        Connector: 'Connector',
        Agent: 'Agent',
        CustomAgent: 'CustomAgent',
        AgentWorkflow: 'AgentWorkflow',
        ModelContainer: 'ModelContainer',
        Analysis: 'Analysis',
        Topic: 'Topic',
        Vantage: 'Vantage',
        ActionBoard: 'ActionBoard',
        Worksheet: 'Worksheet',
        Workstep: 'Workstep',
        ContextComment: 'ContextComment',
        ContextNumeric: 'ContextNumeric',
        ContextLabel: 'ContextLabel',
        Item: 'Item',
        ItemWithOwner: 'ItemWithOwner',
        TypeDefinition: 'TypeDefinition',
        TableDefinition: 'TableDefinition',
        StoredTable: 'StoredTable',
        VersionHistory: 'VersionHistory',
        ApprovalFlowStep: 'ApprovalFlowStep',
        Model: 'Model',
        Hierarchy: 'Hierarchy',
        MarkdownItem: 'MarkdownItem',
        CalculatedTable: 'CalculatedTable',
        Board: 'Board',
        Tile: 'Tile',
        Organization: 'Organization',
    },
    TopicDocumentAttributes: {
        DataSeeqContent: 'data-seeq-content',
        DataSeeqContentPending: 'data-seeq-content-pending',
        DataSeeqDateRangeId: 'data-date-range-id',
        DataSeeqDateRangeFormat: 'data-date-range-format',
        DataSeeqDateRangeContent: 'data-date-range-content',
        DataSeeqContentPercentWidth: 'data-seeq-content-percent-width',
        DataSeeqContentNoMargin: 'data-seeq-content-no-margin',
        DataSeeqContentBorder: 'data-seeq-content-border',
        DataSeeqContentHeight: 'data-seeq-content-height',
        DataSeeqContentWidth: 'data-seeq-content-width',
        DataSeeqContentPropertyOverrides: 'data-seeq-content-property-overrides',
        DataSeeqAssetSelectionId: 'data-asset-selection-id',
        DataSeeqAssetSelectionDepthLevel: 'data-asset-selection-depth-level',
        DataSeeqIframeContentUrl: 'data-iframe-content-url',
        DataSeeqIframeContentHeight: 'data-iframe-content-height',
        DataSeeqIframeContentWidth: 'data-iframe-content-width',
        DataSeeqMarkdownContent: 'data-markdown-content',
    },
    CapsuleProperties: {
        Start: 'Start',
        End: 'End',
        Duration: 'Duration',
        IsUncertain: 'IsUncertain',
        IsBounded: 'IsBounded',
        Middle: 'Middle',
        Count: 'Count',
        Value: 'Value',
        Unit: 'Unit',
        Distance: 'Distance',
        Similarity: 'Similarity',
        StandardDeviation: 'Standard Deviation',
        SamplePeriod: 'Sample Period',
        ReferenceCapsule: 'Reference Capsule',
        ConditionId: 'Condition ID',
        CapsuleId: 'Capsule ID',
        CapsuleIdSafe: 'Capsule SortKey',
        OriginalUncertainty: 'Original Uncertainty',
        IsSuppressed: 'Is Suppressed',
        CapsuleIdProperty: 'Capsule ID Property',
        InternalPrefix: '_SeeqInternal_',
        ThresholdMetric: {
            Priority: 'Priority',
            PriorityName: 'Priority Name',
            Color: 'Color',
        },
    },
    Properties: {
        Guid: 'GUID',
        Name: 'Name',
        Id: 'ID',
        Description: 'Description',
        Unsearchable: 'Unsearchable',
        Archived: 'Archived',
        ArchivalId: 'Archival ID',
        ArchivedAt: 'Archived At',
        ArchivedReason: 'Archived Reason',
        Dashboard: 'Dashboard',
        SyncToken: 'Sync Token',
        NumberFormat: 'Number Format',
        SourceNumberFormat: 'Source Number Format',
        StringFormat: 'String Format',
        SourceStringFormat: 'Source String Format',
        StorageLocation: 'Storage Location',
        ExecutorId: 'Executor ID',
        CreatorId: 'Creator ID',
        CreatorFirstName: 'Creator First Name',
        CreatorLastName: 'Creator Last Name',
        HistoricalDataVersion: 'Historical Data Version',
        ManualCdc: 'Manual CDC',
        ScopedTo: 'Scoped To',
        Asset: 'asset',
        FullPath: 'fullpath',
        Locked: 'Locked',
        LockedMetadata: 'Locked Metadata',
        ImportItemType: 'Import Item Type',
        Filename: 'Filename',
        NameRow: 'Name Row',
        NamePrefix: 'Name Prefix',
        NameSuffix: 'Name Suffix',
        ConditionName: 'Condition Name',
        FirstDataRow: 'First Data Row',
        DescriptionRow: 'Description Row',
        InterpolationMethodRow: 'Interpolation Method Row',
        MaximumInterpolationRow: 'Maximum Interpolation Row',
        ValueUomRow: 'Value Unit of Measure Row',
        FieldDelimiter: 'Field Delimiter',
        DayFirstDefault: 'Day First Default',
        KeyColumnName: 'Key Column Name',
        KeyColumnIndex: 'Key Column Index',
        EndColumnName: 'End Column Name',
        EndColumnIndex: 'End Column Index',
        KeyFormat: 'Key Format',
        TimeZone: 'Time Zone',
        ValueColumnNames: 'Value Column Names',
        ValueColumnIndices: 'Value Column Indices',
        Append: 'Append',
        ValidationMode: 'Validation Mode',
        LenientDaylightSavings: 'Lenient Daylight Savings',
        DatasourceClass: 'Datasource Class',
        DatasourceName: 'Datasource Name',
        DatasourceId: 'Datasource ID',
        DatasourceHostId: 'Datasource Host ID',
        DataId: 'Data ID',
        PreviousDataId: 'Previous Data ID',
        StoredInSeeq: 'Stored In Seeq',
        ConnectionRequestTimeout: 'Connection Request Timeout',
        MaxRequests: 'Max Requests',
        WindowsAuthMode: 'Windows Auth Mode',
        LdapAuthMode: 'LDAP Auth Mode',
        OidcIssuer: 'Oidc Issuer',
        OidcJwtKeySet: 'Oidc JWT Key Set',
        OidcAudience: 'Oidc Audience',
        UsernamePasswordCompatible: 'Username/Password Compatible',
        UsernameHumanReadable: 'Username Human Readable',
        ExpectDuplicatesDuringIndexing: 'Expect Duplicates During Indexing',
        ReferencedDatasourceId: 'Referenced Datasource ID',
        ReferencedDatasourceClass: 'Referenced Datasource Class',
        AdditionalGroupsToSync: 'Additional Groups To Sync',
        SignalLocation: 'Signal Location',
        ConditionLocation: 'Condition Location',
        CurrentIndexAt: 'Current Index At',
        PreviousIndexAt: 'Previous Index At',
        SyncResult: 'Sync Result',
        IndexingScheduleSupported: 'Indexing Schedule Supported',
        SyncMode: 'Sync Mode',
        ItemsArchivedCount: 'Items Archived Count',
        IndexingDuration: 'Indexing Duration',
        ProvidesEveryoneGroupIdentities: 'Provides Everyone Group Identities',
        DatasourceLabels: 'Datasource Labels',
        DatasourceVendor: 'Datasource Vendor',
        ScimMappingGroupExternalId: 'SCIM User Group External ID Mapping',
        ScimMappingSecurityId: 'Security ID',
        ScimMappingObjectId: 'Object ID',
        IndexingProgressTimestamp: 'Indexing Progress Timestamp',
        AssetProgress: 'Asset Progress',
        AssetCount: 'Asset Count',
        PreviousAssetCount: 'Previous Asset Count',
        SignalProgress: 'Signal Progress',
        SignalCount: 'Signal Count',
        PreviousSignalCount: 'Previous Signal Count',
        ConditionProgress: 'Condition Progress',
        ConditionCount: 'Condition Count',
        PreviousConditionCount: 'Previous Condition Count',
        ScalarProgress: 'Scalar Progress',
        ScalarCount: 'Scalar Count',
        PreviousScalarCount: 'Previous Scalar Count',
        RelationshipProgress: 'Relationship Progress',
        RelationshipCount: 'Relationship Count',
        PreviousRelationshipCount: 'Previous Relationship Count',
        UserGroupProgress: 'UserGroup Progress',
        UserGroupCount: 'UserGroups Count',
        PreviousUserGroupCount: 'Previous UserGroups Count',
        AgentUpToDate: 'Up to date.',
        CustomAgentAutomationTriggerKind: 'customAgentAutomationTriggerKind',
        CustomAgentAutomationEnabled: 'customAgentAutomationEnabled',
        CustomAgentAutomationScheduleCron: 'customAgentAutomationScheduleCron',
        CustomAgentAutomationScheduleTimezone: 'customAgentAutomationScheduleTimezone',
        StaleMetadata: 'Stale Metadata',
        InterpolationMethod: 'Interpolation Method',
        SourceMaximumInterpolation: 'Source Maximum Interpolation',
        OverrideMaximumInterpolation: 'Override Maximum Interpolation',
        MaximumInterpolation: 'Maximum Interpolation',
        ValueUom: 'Value Unit Of Measure',
        SourceValueUom: 'Source Value Unit Of Measure',
        DisplayUnit: 'Display Unit',
        UnitsMigrated: 'Units Migrated',
        MaximumDuration: 'Maximum Duration',
        CacheEnabled: 'Cache Enabled',
        PrecachingEnabled: 'Pre-Caching Enabled',
        UncertaintyOverride: 'Uncertainty Override',
        MetadataProperties: 'Metadata Properties',
        LastKeyWritten: 'Last Key Written',
        RequestIntervalClamp: 'Request Interval Clamp',
        OldCacheId: 'Old Cache ID',
        DebounceDuration: 'Debounce Duration',
        DebounceWindow: 'Debounce Window',
        TombstonedProperties: 'Tombstoned Properties',
        MultivaluedSamplesBehavior: 'Multivalued Samples Behavior',
        CapsuleIdProperty: 'Capsule ID Property',
        StoredSeriesCacheVersion: 'Stored Series Cache Version',
        DefaultDebounceDuration: 'Default Debounce Duration',
        DefaultRequestIntervalClamp: 'Default Request Interval Clamp',
        ReplaceCapsuleProperties: 'Replace Capsule Properties',
        Uom: 'Unit Of Measure',
        FormulaVersion: 'Formula Version',
        Formula: 'Formula',
        SwapSourceId: 'Swap Source ID',
        SwapSourceUom: 'Source Value Unit Of Measure',
        SwapKey: 'Swap Key',
        Value: 'Value',
        FormulaParameters: 'FormulaParameters',
        IsModifiedOutsideTable: 'Is Modified Outside Table',
        ExpectedProvidedType: 'ExpectedProvidedType',
        VersionString: 'Version String',
        CreatorName: 'Creator Name',
        CreatorContactInfo: 'Creator Contact Info',
        Title: 'Title',
        Examples: 'Examples',
        SearchKeywords: 'Search Keywords',
        ExperimentalPackageName: 'Experimental',
        SeeqPackageName: 'Seeq',
        IndexDocName: 'index',
        AggregationFunction: 'AggregationFunction',
        Duration: 'Duration',
        Period: 'Period',
        MeasuredItemMaximumDuration: 'MeasuredItemMaximumDuration',
        MeasuredItemId: 'MeasuredItemId',
        MetricConfigurationMigration: 'MetricReconfigurationMigration',
        BoundingConditionMaximumDuration: 'BoundingConditionMaximumDuration',
        NeutralColor: 'NeutralColor',
        Unset: 'unset',
        IsGenerated: 'Is Generated',
        TreeType: 'Tree Type',
        ManuallyAdded: 'Manually Added',
        CreatedBy: 'Created By',
        AssetPath: 'assetPath',
        ColumnType: 'columnType',
        OriginalMapping: 'originalMapping',
        ParameterToColumn: 'parameterToColumn',
        SwapSourceAssetId: 'Swap Source Asset ID',
        ExportData: 'Export Data',
        IsCapsuleView: 'Is Capsule View',
        IsExportCapsuleTable: 'Is Export Capsule Table',
        IsChainView: 'Is Chain View',
        IsAutoupdateTimeRange: 'Is Autoupdate Time Range',
        GridSize: 'Grid Size',
        ExportedItemSchema: 'Exported Item Schema',
        UserEmail: 'User Email',
        Username: 'Username',
        FirstName: 'First Name',
        LastName: 'Last Name',
        PasswordHash: 'Password Hash',
        PasswordHashMethod: 'Password Hash Method',
        PasswordSetDate: 'Password Set Date',
        LastLoginAt: 'Last Login At',
        LastUsed: 'Last Used',
        FailedLoginAttemptCount: 'Failed Login Attempt Count',
        SessionDuration: 'Session Duration',
        AccessKeyExpiry: 'Access Key Expiry',
        AccessKeyValidityDuration: 'Access Key Validity Duration',
        Enabled: 'Enabled',
        Workbench: 'Workbench',
        UserRole: 'User Role',
        Site: 'Site',
        UserLanguage: 'userLanguage',
        RequirePasswordResetOnNextLogin: 'Require Password Reset On Next Login',
        AgentProvisioningStatus: 'Agent Provisioning Status',
        AgentProvisioningSourceAddress: 'Agent Provisioning Source Address',
        AgentProvisioningRequestedAt: 'Agent Provisioning Requested At',
        PasswordResetTokenHash: 'Password Reset Token Hash',
        PasswordResetTokenExpirationAt: 'Password Reset Token Expiration At',
        LastPasswordResetRequestAt: 'Last Password Reset Request At',
        Trusted: 'Trusted',
        RemoteGroupEditable: 'Remote Group Editable',
        RemovePermissions: 'Remove Permissions',
        SourceObjectId: 'Source Object ID',
        SourceSecurityId: 'Source Security ID',
        Data: 'Data',
        CreatedAt: 'Created At',
        UpdatedAt: 'Updated At',
        Order: 'Order',
        RemovedWorksheetWorkstepRelationships: 'Removed Worksheet Workstep Relationships',
        ApprovalFlowId: 'Approval Flow ID',
        StepOrder: 'Step Order',
        LockRequired: 'Lock Required',
        Document: 'Document',
        PlainTextDocument: 'Plain Text Document',
        Discoverable: 'Discoverable',
        PublishedAt: 'Published At',
        LastViewedAt: 'Last Viewed At',
        SourceSecurityString: 'Source Security String',
        SecurityString: 'Security String',
        PermissionsFromDatasource: 'Permissions From Datasource',
        PermissionInheritanceDisabled: 'Permission Inheritance Disabled',
        AssetGroupMember: 'Asset Group Member',
        FirstAdminCreated: 'First Admin Created',
        UIConfig: 'UIConfig',
        DirtyCache: 'Dirty Cache',
        Unmodifiable: 'Unmodifiable',
        Height: 'Height',
        Width: 'Width',
        Scale: 'Scale',
        Timezone: 'Timezone',
        Selector: 'Selector',
        LastScreenshotDuration: 'Last Screenshot Duration',
        ScreenshotWarning: 'Screenshot Warning',
        SummaryType: 'Summary Type',
        SummaryValue: 'Summary Value',
        FillToFit: 'Fill to Fit',
        HideUncertainty: 'Hide Uncertainty',
        AnalysisViewType: 'Analysis View Type',
        CurrentFilename: 'Current Filename',
        LastResultHash: 'Last Result Hash',
        CacheId: 'Cache ID',
        AssetPathDepth: 'Asset Path Depth',
        LastRunState: 'Last Run State',
        QueryRangeLookAhead: 'Query Range Look Ahead',
        WebhookUrl: 'Webhook Url',
        FirstRunLookBack: 'First Run Look Back',
        CapsuleEventTypes: 'Capsule Event Types',
        SampleEventTypes: 'Sample Event Types',
        RemovedMonitoredSeries: 'Removed Monitored Series',
        AddedMonitoredSeries: 'Added Monitored Series',
        FinderConfigurations: 'Finder Configurations',
        IncludeHierarchy: 'Include Hierarchy',
        HierarchySearches: 'Hierarchy Searches',
        ResourceSize: 'Resource Size',
        ProjectType: 'Project Type',
        StartupEnvironment: 'Startup Environment',
        BinaryData: 'Binary Data',
        LastRunAt: 'Last Run At',
        /* DEPRECATED, Deprecated. See SeeqNames.java for more info */
        PreviousRunTime: 'Previous Run Time',
        ScheduledAt: 'Scheduled At',
        TotalRunTime: 'Total Run Time',
        AverageRunTime: 'Average Run Time',
        WallClockRunTime: 'Wall-Clock Run Time',
        CronSchedule: 'Cron Schedule',
        Background: 'Background',
        ConditionFormulaNow: 'Condition Formula Now',
        LastRunWarnings: 'Last Run Warnings',
        LastRunErrors: 'Last Run Errors',
        NotebookPath: 'Notebook Path',
        CronSchedulesToIndices: 'Cron Schedules To Indices',
        Label: 'Label',
        NotifyOnSkippedExecution: 'Notify On Skipped Execution',
        NotifyOnAutomaticUnschedule: 'Notify On Automatic Unschedule',
        AdditionalErrorNotificationRecipients: 'Additional Error Notification Recipients',
        IsFixedWith: 'Is Fixed Width',
        MarginTop: 'Margin Top',
        MarginBottom: 'Margin Bottom',
        MarginLeft: 'Margin Left',
        MarginRight: 'Margin Right',
        Orientation: 'Page Orientation',
        PageSize: 'Page Size',
        IsCkEnabled: 'Is CK Enabled',
        FroalaBackup: 'Froala Backup',
        OriginalHasWorkstepGuid: 'Original HasWorkstep GUID',
        InDevelopment: 'In Development',
        IconClass: 'Icon Class',
        TargetUrl: 'Target URL',
        LaunchLocation: 'Launch Location',
        LinkType: 'Link Type',
        WindowDetails: 'Window Details',
        ReuseWindow: 'Reuse Window',
        SortKey: 'Sort Key',
        AddOnIdentifier: 'Add-on Identifier',
        AddOnComponents: 'Add-on Components',
        HtmlTemplate: 'HTML Template',
        PlainTextTemplate: 'Plain Text Template',
        Category: 'Category',
        Identifier: 'Identifier',
        Location: 'Location',
        EntryPoint: 'Entry Point',
        Icon: 'Icon',
        LastUpdateTime: 'Last Update Time',
        Host: 'Host',
        Options: 'Options',
        Version: 'Version',
        Json: 'Json',
        PropagationPending: 'Propagation Pending',
        DatasourceManaged: 'Datasource Managed',
        ConnectionId: 'ConnectionId',
        IndexingConnection: 'Indexing Connection',
        PullConnection: 'Pull Connection',
        MaxConcurrentRequests: 'Max Concurrent Requests',
        MaxResultsPerRequests: 'Max Results Per Requests',
        Transforms: 'Transforms',
        Type: 'Type',
        IndexingFrequency: 'Indexing Frequency',
        NextScheduledIndexAt: 'Next Scheduled Index At',
        DisabledAt: 'Disabled At',
        DisabledBy: 'Disabled By',
        IndexingOnStartupAndConfigChange: 'Indexing On Startup And Config Change',
        ColumnDefinitions: 'Column Definitions',
        BatchAction: 'Batch Action',
        TableType: 'Table Type',
        NavigationColumnId: 'Navigation Column Id',
        IsContextCondition: 'Is Context Condition',
        VersionedItemType: 'Versioned Item Type',
        ProductionVersionNumber: 'Production Version Number',
        Versions: 'Versions',
        AgentWorkflowJson: 'AgentWorkflowJson',
        Inputs: 'Inputs',
        ResultType: 'Result Type',
        ViewColumns: 'View Columns',
        FilterGrouping: 'Filter Grouping',
        AliasColumnId: 'Alias Column ID',
        TableDefinitionId: 'Table Definition Id',
        ConstructedDataId: 'Constructed Data Id',
        ItemTableId: 'Item Table Id',
        Alias: 'Alias',
        SourceColumnId: 'Source Column Id',
        Features: 'Features',
        CreatedByModelInstance: 'Created By Model Instance',
        InstanceRetired: 'Instance Retired',
        Markdown: 'Markdown',
        Purpose: 'Purpose',
        Query: 'Query',
        CalculatedTableColumnMetadata: 'Calculated Table Column Metadata',
        CalculatedTableColumnDependency: 'Calculated Table Column Dependency',
        CalculatedTableSourceTableId: 'Calculated Table Source Table Id',
        CalculatedTableJoins: 'Calculated Table Joins',
        VantageViewDefinitions: 'Vantage View Definitions',
        Columns: 'Columns',
        RowHeight: 'Row Height',
        BackgroundColor: 'Background Color',
        AppliedFilter: 'Applied Filter',
        CalculatedTableId: 'Calculated Table Id',
        UsersShared: 'Users Shared',
        TopicsShared: 'Topics Shared',
        WorkbooksShared: 'Workbooks Shared',
        UsersAccessedLastWeek: 'Users Accessed Last Week',
        TopicsAccessedLastWeek: 'Topics Accessed Last Week',
        WorkbooksAccessedLastWeek: 'Workbooks Accessed Last Week',
        TotalItemsShared: 'Total Items Shared',
        HostsExternalOrganization: 'Hosts External Organization',
        OrganizationFolderId: 'Folder ID',
        OrganizationUserGroupId: 'User Group ID',
        Source: 'Source',
        ApplicationId: 'Application ID',
        WorkbookState: 'workbookState',
    },
} as const;


